/* RESPONSIBLE TEAM: team-frontend-tech */

export type ErrorCategory = 'timeout' | 'init-failure' | 'script-load' | 'unknown';

const ERROR_PATTERNS: Record<Exclude<ErrorCategory, 'unknown'>, RegExp> = {
  timeout: /timed out/,
  'init-failure': /not found after loading/,
  'script-load': /Failed to load script/,
};

export function categorizeErrorMessage(message: string): ErrorCategory {
  for (let [category, pattern] of Object.entries(ERROR_PATTERNS)) {
    if (pattern.test(message)) {
      return category as ErrorCategory;
    }
  }
  return 'unknown';
}

export function categorizeBootError(error: Error | Event): ErrorCategory {
  if (error instanceof Event) {
    return 'script-load';
  }
  return categorizeErrorMessage(error.message ?? '');
}
